/**
 * workaround for: http://jira.upplication.priv:8080/browse/UPP-2705
 */
(function ($UPP, document, $) {
    'use strict';

    $(function () {
        function _toggleVideo(state) {

            $("iframe[src*=youtu]").each(function (i, elem) {

                if (elem.src.indexOf('enablejsapi') == -1) {
                    if (elem.src.indexOf('?') == -1) elem.src = elem.src + "?enablejsapi=1";
                    else elem.src = elem.src + "&enablejsapi=1";
                }

                var iframe = elem.contentWindow;

                if (elem.style && elem.style.display == 'none') {
                    elem.style.display = state == 'hide' ? 'none' : '';
                } else {
                    elem.style.display = state == 'hide' ? 'none' : '';
                    var func = state == 'hide' ? 'pauseVideo' : 'playVideo';
                    iframe.postMessage('{"event":"command","func":"' + func + '","args":""}', '*');
                }
            });
        }

        if ($UPP.PHONEGAP && $UPP.ANDROID) {
            document.addEventListener("deviceready", function () {
                document.addEventListener("pause", function () {
                    _toggleVideo('hide');
                }, false);

                document.addEventListener("resume", function () {
                    _toggleVideo();
                }, false);
            }, false);
        }
    });

})(window.$UPP, document, window.jQuery);



// WEBPACK FOOTER //
// ./src/app/common/utils/android-youtube-pause.js